import { ChangeDetectionStrategy, Component, inject, input, Input, OnInit } from '@angular/core';
import { StateComponent } from '../../../../../../../../components/state/state.component';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IDropdownConfig } from '../../common/model/betting.model';
import { BettingTypeKey } from '@oogaday/shared';
import { UtilsService } from '../../../../../../../../services/utils.service';
import { MatDivider } from '@angular/material/divider';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';


@Component({
  selector: 'oo-in-order-qualifires',
  templateUrl: './in-order-qualifires.component.html',
  styleUrls: ['./in-order-qualifires.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatFormField, MatLabel, MatSelect, FormsModule, ReactiveFormsModule, MatOption, MatError, MatDivider],
})
export class InOrderQualifiresComponent extends StateComponent<InOrderQualifiresComponentState> implements OnInit {

  readonly bettingForm = input.required<FormGroup>();
  readonly key = input.required<BettingTypeKey>();
  readonly initValue = input<number[][]>();
  state: InOrderQualifiresComponentState = {
    dropdowns: [],
    form: null!,
    numOfSelections: null!,
    placesLabels: [
      '1st',
      '2nd',
      '3rd',
      '4th',
      '5th',
    ],
  };
  private readonly fb = inject(FormBuilder);

  @Input() set dropdowns(dropdowns: IDropdownConfig[]) {
    this.updateState({ dropdowns });
  }

  @Input() set numOfSelections(numOfSelections: number) {
    this.updateState({ numOfSelections });
  }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm(): void {
    this.updateState({
      form: this.fb.array(this.state.dropdowns.map((dropdown, index) =>
        this.fb.array(
          UtilsService.genArray(this.state.numOfSelections).map(
            (i) => this.fb.nonNullable.control(this.initValue()?.[index][i], [Validators.required]),
          ),
        ),
      )),
    });

    this.bettingForm().addControl(this.key(), this.state.form);
    this.detectChangesAfterTick();
  }
}

interface InOrderQualifiresComponentState {
  dropdowns: IDropdownConfig[];
  form: FormArray<FormArray<FormControl<number | undefined>>>;
  numOfSelections: number;
  placesLabels: string[];
}
